import { render, staticRenderFns } from "./adDomainData.vue?vue&type=template&id=61e61eb1&scoped=true"
import script from "./adDomainData.vue?vue&type=script&lang=js"
export * from "./adDomainData.vue?vue&type=script&lang=js"
import style0 from "./adDomainData.vue?vue&type=style&index=0&id=61e61eb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e61eb1",
  null
  
)

export default component.exports